import React from 'react';
import { InputAdornment } from '@mui/material';
import { FaSearch } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import { CustomAutocomplete } from '../../../../../shared/components/Autocomplete';
import { useTranslation } from 'react-i18next';
import { ICompanyUsersFilter } from '../../dto/ICompany';
import { SearchInput } from '../../../../../shared/components/SearchInput';

interface UserAndRolesFilterProps {
    setFilterParams: React.Dispatch<React.SetStateAction<ICompanyUsersFilter>>;
    filters: ICompanyUsersFilter;
    isBrand: boolean;
    isFilterLoading?: boolean;
}

const UserAndRolesFilter = ({
    setFilterParams,
    filters,
    isBrand,
    isFilterLoading = false,
}: UserAndRolesFilterProps) => {
    const { t } = useTranslation();
    const UserPositionEnum = useSelector((state: IAllStates) =>
        isBrand ? state.enums?.BrandUserPositionEnum : state.enums?.AgencyUserPositionEnum
    );

    const handleSearch = (value: string, name: string) => {
        setFilterParams(prevState => ({ ...prevState, [name]: value, page: 1 }));
    };

    const changePositionHandler = (_paramKey: string, paramValue: string | string[] | number) => {
        setFilterParams(prevState => ({
            ...prevState,
            position: paramValue as string,
            page: 1,
        }));
    };

    return (
        <div className="d-md-flex w-md-50 mb-3 mb-md-0">
            <SearchInput
                name="displayName"
                defaultValue={filters?.displayName ?? ''}
                onSearch={handleSearch}
                isLoading={isFilterLoading}
                label={t('general.button.search')}
                className="w-sm-50 w-100 mr-3 mb-3 mb-md-0"
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end" className="pr-2">
                            <FaSearch className="text-muted" size={16} />
                        </InputAdornment>
                    ),
                }}
            />
            <CustomAutocomplete
                dataArray={UserPositionEnum ?? []}
                defaultArray={filters?.position ?? undefined}
                isWithImage={false}
                inputLabel="position"
                isMultiple={false}
                photoLabel=""
                queryFilterKey=""
                inputLabelTranslation={t('brand.account.users_and_roles_modal.position')}
                handleChangeParams={changePositionHandler}
                isDisabled={isFilterLoading}
            />
        </div>
    );
};

export default UserAndRolesFilter;
